// extracted by mini-css-extract-plugin
module.exports = {"container":"_3ioc0ceVSMn-2q1iKkuWyT","icon":"_2tyi5ClsA8bsPZX6L29Giq"};